import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/applications')({
  component: Outlet,
  head: () => ({ meta: [{ title: 'Applications' }] }),
});
